var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "relative flex flex-col justify-center items-center py-6 lg:py-12 my-4 lg:my-12 mx-4 lg:mx-24 xl:mx-64 bg-[#eef4ff] rounded-[12px] lg:rounded-[30px]",
    },
    [
      _c(
        "h3",
        {
          staticClass:
            "text-base lg:text-2xl text-gray-800 leading-[25px] lg:leading-[44px] font-semibold px-4",
        },
        [
          _vm._v(
            " 中小非标机械厂，选择轻熵科技 ERP&MES 一体化管理系统，交期&库存管理无烦恼 "
          ),
        ]
      ),
      _c("div", { staticClass: "mt-4 lg:mt-10 flex justify-center gap-x-6" }, [
        _c(
          "a",
          {
            staticClass:
              "contact-me inline-flex justify-center items-center p-0 mt-3 rounded-[16px] lg:rounded-[24px] w-[130px] h-[36px] lg:w-[170px] lg:h-[48px] bg-[#3e90ff] text-white hover:text-white text-sm lg:text-lg",
            attrs: { href: "/apply", target: "_blank" },
          },
          [
            _vm._v(" 联系我们 "),
            _c("a-icon", {
              staticClass: "contact-icon ml-[18px]",
              attrs: { type: "arrow-right" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }